// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ModelAssociationFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'cashFlowCustomModelId': !exists(json, 'cashFlowCustomModelId') ? undefined : json['cashFlowCustomModelId'],
        'cashflowModelId': !exists(json, 'cashflowModelId') ? undefined : json['cashflowModelId'],
        'fundId': !exists(json, 'fundId') ? undefined : json['fundId'],
        'investorAccountId': !exists(json, 'investorAccountId') ? undefined : json['investorAccountId'],
        'assetClass': !exists(json, 'assetClass') ? undefined : json['assetClass'],
        'strategy': !exists(json, 'strategy') ? undefined : json['strategy'],
        'isPredefined': !exists(json, 'isPredefined') ? undefined : json['isPredefined'],
    };
}
export function ModelAssociationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'cashFlowCustomModelId': value.cashFlowCustomModelId,
        'cashflowModelId': value.cashflowModelId,
        'fundId': value.fundId,
        'investorAccountId': value.investorAccountId,
        'assetClass': value.assetClass,
        'strategy': value.strategy,
        'isPredefined': value.isPredefined,
    };
}
